import React from 'react';
import { Box } from '@mui/material';

export interface ValidationMessagesProps {
  messages: { type: 'success' | 'warning'; content: React.ReactNode }[];
}

const ValidationMessages: React.FC<ValidationMessagesProps> = ({ messages }) => {
  if (!messages.length) return null;
  
  // Check if there are any warnings
  const hasWarnings = messages.some(m => m.type === 'warning');
  
  // If there are warnings, only show warnings (filter out success messages)
  const messagesToShow = hasWarnings ? messages.filter(m => m.type === 'warning') : messages;
  
  // Only show success message if there are no warnings and only one success message
  const onlySuccess = !hasWarnings && messagesToShow.length === 1 && messagesToShow[0].type === 'success';
  if (onlySuccess) {
    return <>{messagesToShow[0].content}</>;
  }
  
  return (
    <Box
      sx={{
        mt: 3,
        width: '100%',
        border: '2.5px solid #ff5252',
        background: '#18171a',
        borderRadius: 6,
        p: 3,
        mb: 4,
      }}
    >
      {messagesToShow.map((msg, idx) => (
        <Box key={idx} sx={{ mb: idx < messagesToShow.length - 1 ? 2.5 : 0 }}>
          {msg.content}
        </Box>
      ))}
    </Box>
  );
};

export default ValidationMessages; 